export default function BicyclesServiceProvider() {
  this.$get = ($t) => {
    'ngInject';

    function BicyclesService() {

      const self = this;

      self.bicycleStatuses = [
        {value: 'USED', label: $t('shared.bicycle_status.USED')},
        {value: 'BROKEN', label: $t('shared.bicycle_status.BROKEN')},
        {value: 'IN_TRANSFER', label: $t('shared.bicycle_status.IN_TRANSFER')},
      ];

      self.getWheelLabel = wheel => {
        let result = '';
        if (wheel.inch) {
          result += wheel.inch;
        }

        if (wheel.iso) {
          if (result) {
            result += ' / ';
          }

          result += wheel.iso;
        }

        if (wheel.bicycleStandard) {
          if (result) {
            result += ' / ';
          }

          result += wheel.bicycleStandard;
        }

        return result;
      };

      self.mapStatusValue = values => {
        if (Array.isArray(values)) {
          return values.map(value => $t('shared.bicycle_status.' + value))
            .join(',');
        }

        return values;
      }

    }

    return new BicyclesService();
  };
}